import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { withCurrentSearch } from "@/utils/searchParams";
import { getHorizonScanningApi } from "./api";

export function RecipientConfirmScreen() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError("Missing confirm token.");
      return;
    }
    getHorizonScanningApi()
      .confirmRecipient(token)
      .then((r) => setMessage(r.message || `Confirmed ${r.email}.`))
      .catch((err: unknown) =>
        setError(err instanceof Error ? err.message : "Could not confirm this invite."),
      );
  }, [token]);

  if (error) {
    return (
      <div className="mx-auto max-w-xl px-5 py-16">
        <h1 className="text-2xl font-bold text-ink">Invite unavailable</h1>
        <p className="mt-3 text-ink-soft">{error}</p>
      </div>
    );
  }

  if (!message) {
    return (
      <div className="mx-auto max-w-xl px-5 py-16">
        <p className="text-ink-soft">Confirming your email…</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-xl px-5 py-16">
      <h1 className="text-2xl font-bold text-ink">You are on the digest</h1>
      <p className="mt-3 text-ink-soft">{message}</p>
      <p className="mt-4 text-sm text-ink-muted">
        You will receive the same emails as the admin. No password or platform account was created.
      </p>
      <Link className="mt-6 inline-block font-semibold text-brand-700" to={withCurrentSearch("/landing/horizonscanning/")}>
        About horizon scanning
      </Link>
    </div>
  );
}
